<template>
    <div class="page-container">
        <div class="invoice-item">
            <div class="company-name">北京XXX科技有限公司</div>
            <div class="tax-number">企业税号: <span>KJLKGJAKLJDFA0931928</span></div>
        </div>
        <div class="invoice-item">
            <div class="company-name">北京XXX科技有限公司</div>
            <div class="tax-number">企业税号: <span>KJLKGJAKLJDFA0931928</span></div>
        </div>
        <div class="btn-normal">新增</div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="scss" scoped>
@mixin one-overflow{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.page-container{
    min-height:calc(100vh - 46px);
    background:#fafafa;
    box-sizing: border-box;
    padding:10px;
    padding-bottom: 60px;
    .invoice-item{
        margin-bottom: 10px;
        background:#fff;
        padding:15px 20px;
        @media screen and (max-width: 750px){
            border-radius: 4px;
        }
        .company-name{
            color:#333;
            font-size: 14px;
            line-height: 20px;
            @include one-overflow;
            margin-bottom: 10px;
        }
        .tax-number{
            color:#333;
            font-size: 14px;
            line-height: 20px;
            @include one-overflow;
            &>span{
                color:#999;
            }
        }
    }
    .btn-normal{
        width: 180px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: linear-gradient(90deg, #3088F5 0%, #3CA7FE 100%);
        border-radius: 26px;
        color:#fff;
        font-size: 16px;
        position: fixed;
        bottom:20px;
        left:50%;
        transform: translateX(-50%);
        &.disabled{
            background:#dcdcdc;
            color:#999;
        }
    }
}
</style>